import { render, staticRenderFns } from "./ApacheChar.vue?vue&type=template&id=58200dd4&scoped=true"
import script from "./ApacheChar.vue?vue&type=script&lang=js"
export * from "./ApacheChar.vue?vue&type=script&lang=js"
import style0 from "./ApacheChar.vue?vue&type=style&index=0&id=58200dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58200dd4",
  null
  
)

export default component.exports